import { RESOURCE_KEYS, AT_TYPES } from "../../../constants/entity.js";

export function getIconByType(type) {
  switch (type) {
    case RESOURCE_KEYS.WORKSTATIONS:
    case AT_TYPES.SERVICES.WORKSTATION:
    case AT_TYPES.WORKSTATION:
      return "desktop";
    case RESOURCE_KEYS.DISPLAY_GATEWAYS:
    case AT_TYPES.SERVICES.DISPLAY_GATEWAY:
    case AT_TYPES.DISPLAY_GATEWAY:
      return "sitemap";
    case RESOURCE_KEYS.CONTAINERS:
    case AT_TYPES.SERVICES.CONTAINER:
    case AT_TYPES.CONTAINER:
      return "hdd";
    case RESOURCE_KEYS.DATABASES:
    case AT_TYPES.SERVICES.DATABASE:
    case AT_TYPES.DATABASE:
      return "database";
    case RESOURCE_KEYS.NODES:
    case AT_TYPES.SERVICES.NODE:
    case AT_TYPES.NODE:
      return "server";
    case RESOURCE_KEYS.SNOWFLAKES:
    case AT_TYPES.SERVICES.SNOWFLAKE:
    case AT_TYPES.SNOWFLAKE:
      return "snowflake";
    case RESOURCE_KEYS.VPN_GATEWAYS:
    case AT_TYPES.SERVICES.VPN_GATEWAY:
    case AT_TYPES.VPN_GATEWAY:
      return "shield";
    default:
      return "bug";
  }
}
